import { Outlet } from "react-router-dom";


function PatientRootLayout() {
    return (
        <>
            <main>
                <Outlet />
            </main>
        </>
    );

}

export default PatientRootLayout;
